<template>
  <v-layout row justify-center>
    <v-dialog v-model="startDialog" width="600px">
      <v-card>
        <v-card-title class="headline">{{ dialogContents.title }}
        </v-card-title>
        <v-card-text>
          <template v-for="item in dialogContents.sections">
            <h2 :key="item.id">{{ item.title }}</h2>
            <template v-for="(para, pindex) in item.contents">
              <p :key="`${item.id}-pi-${pindex}`" v-html="para"></p>
            </template>
            <template v-if="item.list">
              <ul class="space-list" :key="`ul-${item.id}`">
                <li v-for="(li, lindex) in item.list" :key="`li-${lindex}`" v-html="li"></li>
              </ul>
            </template>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary" flat="flat"
            href="static/handbook.pdf"
            target="_blank">Download Handbook</v-btn>
          <v-btn color="primary" flat="flat" @click="startDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import {mapState, mapActions} from 'vuex'

export default {
  props: ['dialogContents'],
  computed: {
    ...mapState(['showStartDialog']),
    startDialog: {
      get () {
        return this.showStartDialog
      },
      set (startDialog) {
        this.toggleStartDialog(startDialog)
      }
    }
  },
  methods: {
    ...mapActions(['toggleStartDialog'])
  }
}
</script>

<style scoped>
  >>> .space-list {
    margin-top: -1em;
    margin-bottom: 1em;
  }

  >>> .search_example {
    display: block;
    margin-bottom: 1.4em;
    padding: 0 .4em 0 .4em;
  }

  >>> .search_example p {
    font-weight: 600;
    margin: 0.3em;
  }

  >>> .search_example_box {
    padding: 0 .3em 0 .3em;
    margin: 0 .2em 0 .2em;

    background: #FAFAFA;
    border: 1px solid #EEEEEE;
    font-family: sans-serif;
    font-weight: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/StartDialog.vue